import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { testimonials } from '../../data/content';
export function Testimonials() {
  return <section className="bg-ink-950 py-12 sm:py-16" aria-labelledby="testimonials-title" data-id="element-295" data-mp="3mh2adt3b3cf2">
      <div className="mx-auto w-full max-w-4xl px-4 sm:px-6" data-id="element-296" data-mp="3r7irpoa8zi6p">
        <h2 id="testimonials-title" className="text-center font-display text-[1.75rem] font-extrabold uppercase leading-[1.02] text-white sm:text-4xl" data-id="element-297" data-mp="3r8tr7bwnu3s0">
          What other technicians are saying
        </h2>

        <div className="mt-4 flex flex-col items-center gap-1.5" data-id="element-298" data-mp="925ottszvuq1">
          <div className="flex items-center gap-1" aria-hidden="true" data-id="element-299" data-mp="8zt8tm6srufm">
            {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-6 w-6 fill-gold-500 text-gold-500" data-id="element-300" data-mp="2atirec7hpqix" data-mpi={i} />)}
          </div>
          <p className="font-display text-lg font-extrabold uppercase tracking-wide text-gold-400" data-id="element-301" data-mp="2fru0gkpynx03">
            4.9/5 customer rating
          </p>
        </div>

        <p className="mx-auto mt-4 max-w-xl rounded-lg border border-white/10 bg-white/[0.04] px-3 py-2 text-center text-xs leading-snug text-steel-500" data-id="element-302" data-mp="1smm49p0l893e">
          Note: Replace the examples below with verified customer testimonials
          before publishing.
        </p>

        <ul className="mt-7 grid gap-4 sm:grid-cols-2" data-id="element-303" data-mp="1eupevsqb0dap">
          {testimonials.map((t, i) => <li key={i} className={`flex h-full flex-col rounded-2xl border border-white/10 bg-ink-900 p-4 sm:p-5 ${i === testimonials.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-304" data-mp="2bivcvwsq07g0" data-mpi={i}>
              <QuoteIcon className="h-6 w-6 shrink-0 fill-gold-500 text-gold-500" aria-hidden="true" data-id="element-305" data-mp="1xjm6tpy8atpr" />
              <blockquote className="mt-2 flex-1 text-[15px] leading-relaxed text-white sm:text-base" data-id="element-306" data-mp="r4bn83bmsggn">
                “{t.quote}”
              </blockquote>
              <div className="mt-4 flex items-center gap-3 border-t border-white/10 pt-3" data-id="element-307" data-mp="nlw0z18qtsjf">
                <img src={t.photo} alt={`Portrait of ${t.name}`} className="h-12 w-12 shrink-0 rounded-full object-cover ring-2 ring-gold-500/60" width={96} height={96} loading="lazy" data-id="element-308" data-mp="skgzmw8ck45r" />
                <div className="min-w-0" data-id="element-309" data-mp="4umocj3oennm">
                  <p className="truncate text-sm font-bold text-white" data-id="element-310" data-mp="4tk06ixqmzbe">{t.name}</p>
                  <p className="truncate text-xs text-steel-500" data-id="element-311" data-mp="9mmu4s6fgas4">{t.location}</p>
                </div>
                <div className="ml-auto flex items-center gap-0.5" aria-hidden="true" data-id="element-312" data-mp="3r3nvamacqoks">
                  {Array.from({
                length: 5
              }).map((_, s) => <StarIcon key={s} className="h-3.5 w-3.5 fill-gold-500 text-gold-500" data-id="element-313" data-mp="3i1od3qnlpeg9" data-mpi={s} />)}
                </div>
              </div>
            </li>)}
        </ul>

        <div className="mx-auto mt-8 max-w-xl" data-id="element-314" data-mp="33fhkrghjuzwk">
          <CTAButton label="I want results like these" sub="Instant access for $27 USD" size="md" data-id="element-315" data-mp="2yg4mlzl8a6eo" />
        </div>
      </div>
    </section>;
}